"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectListFilter = void 0;
class ProjectListFilter {
    constructor(data) {
        this.limit = 25;
        this.skip = 0;
        this.orderBy = "id";
        this.order = "DESC";
        this.term = null;
        this.projectStatus = [];
        this.targetStatus = [];
        this.status = ['active'];
        this.type = [];
        this.actionCodes = [];
        this.startDate = null;
        this.endDate = null;
        this.checkDate = null;
        this.populationSample = [];
        this.populationSize = null;
        this.populationCategory = [];
        this.revenue = 0.00;
        if (data) {
            this.limit = data.limit || 25;
            this.skip = data.skip || 0;
            this.orderBy = data.orderBy || "id";
            this.order = data.order || "DESC";
            this.keyAccount = data.keyAccount || [];
            this.term = data.term || null;
            this.projectStatus = data.projectStatus || [];
            this.targetStatus = data.targetStatus || [];
            this.status = data.status || [];
            this.type = data.type || [];
            this.actionCodes = data.actionCodes || [];
            this.startDate = data.startDate || null;
            this.checkDate = data.checkDate || null;
            this.endDate = data.endDate || null;
            this.populationSample = data.populationSample || [];
            this.populationSize = data.populationSize || null;
            this.populationCategory = data.populationCategory || [];
            this.revenue = data.revenue || 0.00;
            this.name = data.name || [];
            this.clientName = data.clientName || [];
        }
    }
}
exports.ProjectListFilter = ProjectListFilter;
//# sourceMappingURL=ProjectListFilter.js.map